// Initialize Lenis
const lenis = new Lenis({
  autoRaf: true,
});

let domcModal = document.getElementById("domc-modal");
let domcHider = document.getElementById("domc-hider");
let domcForm = document.getElementById("domc-form");
let domcNotNow = document.getElementById("domc-not-now");
let domcDontShow = document.getElementById("domc-dont-show");

// 1. Function to get a specific cookie by name
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

// 2. Check if "domc" is explicitly set to "false"
setTimeout(() => {
if (getCookie('domc') != "false") {
  domcModal.style.display = 'block';
  domcHider.style.display = 'block';
  // lenis.stop();
  // Add any specific logic you want to run when it's false
}  
}, 10000);


domcForm.addEventListener('submit', (e) => {
    // Prevent page refresh if you're handling this via AJAX/Fetch
    // e.preventDefault(); 

    // Set the cookie
    document.cookie = "domc=false; path=/; SameSite=Lax";
    // Immediate UI feedback: Hide the modal
    if (domcModal) {
      domcModal.style.display = 'none';
      domcHider.style.display = 'none';
      // lenis.start();
    }
  });


domcNotNow.addEventListener("click", function() {
    domcModal.style.display = 'none';
      domcHider.style.display = 'none';
      // 1. Calculate the date 14 days from now
const date = new Date();
date.setTime(date.getTime() + (14 * 24 * 60 * 60 * 1000));

// 2. Convert to UTC string
const expires = "expires=" + date.toUTCString();
      // lenis.start();
      document.cookie = "domc=false; path=/; SameSite=Lax; " + expires;
});
domcHider.addEventListener("click", function() {
    domcModal.style.display = 'none';
      domcHider.style.display = 'none';
      // lenis.start();
});

domcDontShow.addEventListener("click", function() {
    domcModal.style.display = 'none';
      domcHider.style.display = 'none';
      // lenis.start();
      document.cookie = "domc=false; path=/; SameSite=Lax";
});

// lenis.on('scroll', (e) => {
  
// });